/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.9.9",
    versionName: "0.2.0-nightly.2025.9.9",
    versionChannel: "nightly",
    buildDate: "2025-09-09T00:08:52.813Z",
    commitHash: "83f7c37e6e05965da9c940b5b5dd3392a1312c0d",
};
